import styled from 'styled-components'

export const PageContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 40px 20px;
  margin: 0 auto;

  h2 {
    font-size: 1.8rem;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0;
  }

  @media screen and (min-width: 961px) {
    margin: 30px auto;
  }
`

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 24px;

  .back-button {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.secondary};
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s;

    svg {
      color: #fff;
    }

    &:hover {
      opacity: 0.9;
    }
  }

  h2 {
    font-size: 1.8rem;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0;
  }
`

export const PageContent = styled.div`
  padding: 0;
`

export const SavedSchedulesSection = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  border: 1px solid #e9ecef;

  .saved-section-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }

  .saved-section-description {
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.gray70};
    margin: 0;
    flex: 1;
  }

  .header-buttons {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }

  .new-period-button {
    background: ${({ theme }) => theme.colors.secondary};
    border: none;
    color: #fff;
    font-size: 1.2rem;
    font-weight: 500;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      opacity: 0.9;
    }
  }

  .template-button-header {
    background: #fff;
    border: 1px solid ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.2rem;
    font-weight: 500;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: ${({ theme }) => theme.colors.secondary};
      color: #fff;
    }
  }

  .saved-title {
    font-size: 1.6rem;
    font-weight: 600;
    color: #0c111d;
    margin: 0 0 16px 0;
  }

  .saved-schedule-card {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .card-header {
    display: flex;
    background: #fff;
    justify-content: space-between;
    margin-bottom: 16px;
    gap: 16px;
    padding: 0;
    border: none;
    .period-dates {
      font-size: 1.8rem;
      color: #0c111d;
      margin: 0;
    }
  }

  .card-actions {
    display: flex;
    gap: 8px;
  }

  .action-button {
    background: #fff;
    border: none;
    padding: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    img {
      width: 20px;
      height: 20px;
    }

    &:hover {
      opacity: 0.7;
    }
  }

  .week-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 12px;

    @media screen and (max-width: 900px) {
      grid-template-columns: repeat(4, 1fr);
    }

    @media screen and (max-width: 600px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (max-width: 400px) {
      grid-template-columns: 1fr;
    }
  }

  .day-column {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .day-name {
      font-size: 1.1rem;
      font-weight: 600;
      color: #1a1a1a;
    }

    .day-hours {
      font-size: 1rem;
      color: #666;
    }
  }
`

export const DateRangeSection = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  border: 1px solid #e9ecef;

  .date-range-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 16px;
  }

  .section-title {
    font-size: 1.4rem;
    font-weight: 500;
    color: #1a1a1a;
    margin: 0 0 4px 0;
  }

  .section-subtitle {
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.secondary};
    margin: 0;
    background: rgb(255, 228, 235);
    padding: 6px 12px;
    border-radius: 6px;
    display: inline-block;
    margin-top: 8px;
  }

  .template-button {
    background: none;
    border: 1px solid ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.3rem;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px 16px;
    border-radius: 8px;
    transition: all 0.2s;

    &:hover {
      background: ${({ theme }) => theme.colors.secondary};
      color: #fff;
    }
  }

  .date-inputs {
    display: flex;
    flex-direction: row;
    gap: 24px;
    align-items: flex-start;

    @media screen and (max-width: 500px) {
      flex-direction: column;
    }
  }

  .input-group {
    display: flex;
    flex-direction: column;

    label {
      display: block;
      font-size: 1.2rem;
      color: #666;
      margin-bottom: 8px;
    }
    select {
      padding: 12px 14px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      font-size: 1.3rem;
      color: #333;
      background: #fff;
      outline: none;
      cursor: pointer;
      max-width: 300px;

      &:focus {
        border-color: ${({ theme }) => theme.colors.secondary};
      }
    }
  }

  .input-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 12px 14px;
    min-width: 180px;

    svg {
      color: #999;
      flex-shrink: 0;
    }

    input {
      border: none;
      outline: none;
      font-size: 1.3rem;
      color: #333;
      width: 100%;
      background: transparent;

      &::placeholder {
        color: #999;
      }
    }
  }

  .date-error {
    color: #dc3545;
    font-size: 1.2rem;
    margin: 12px 0 0 0;
    padding: 8px 12px;
    background: #fff5f5;
    border-radius: 6px;
    border: 1px solid #ffcdd2;
  }
`

export const WeekScheduleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;

  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

export const DayCard = styled.div<{ isEmpty?: boolean }>`
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e9ecef;

  .day-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .day-name {
    font-size: 1.4rem;
    font-weight: 600;
    color: #1a1a1a;
  }

  .add-time-button {
    background: none;
    border: none;
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.2rem;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
      text-decoration: underline;
    }
  }

  .no-schedule-text {
    font-size: 1.2rem;
    color: #999;
    text-align: center;
    padding: 20px 0;
    margin: 0;
  }

  .time-slot {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .time-input-group {
    flex: 1;

    label {
      display: block;
      font-size: 1.1rem;
      color: #666;
      margin-bottom: 6px;
    }
  }

  .time-input-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 10px 12px;

    svg {
      color: #999;
    }

    input {
      border: none;
      outline: none;
      font-size: 1.2rem;
      color: #333;
      flex: 1;
      background: transparent;
      width: 60px;

      &::-webkit-calendar-picker-indicator {
        display: none;
      }
    }
  }

  .remove-slot-button {
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    svg {
      color: #ff6b6b;
    }

    &:hover {
      background: #fff5f5;
      border-color: #ff6b6b;
    }
  }
`

export const ExceptionsSection = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e9ecef;

  .exceptions-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 16px;

    h3 {
      font-size: 1.4rem;
      font-weight: 600;
      color: #1a1a1a;
      margin: 0 0 4px 0;
    }

    p {
      font-size: 1.2rem;
      color: #666;
      margin: 0;
    }
  }

  .add-exception-button {
    background: none;
    border: none;
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.3rem;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
      text-decoration: underline;
    }
  }

  .no-exceptions-text {
    font-size: 1.3rem;
    color: #999;
    text-align: center;
    padding: 20px 0;
    margin: 0;
  }

  .exceptions-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .exception-item-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    background: #fafafa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
  }

  .exception-reason-row {
    width: 100%;
  }

  .exception-fields-row {
    display: flex;
    gap: 16px;
    align-items: flex-end;
    flex-wrap: wrap;
  }

  .exception-input-group {
    display: flex;
    flex-direction: column;
    min-width: 140px;

    &.full-width {
      width: 100%;
    }

    label {
      display: block;
      font-size: 1.1rem;
      color: #666;
      margin-bottom: 6px;
    }

    .reason-input {
      width: 100%;
      padding: 12px 14px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      font-size: 1.2rem;
      color: #333;
      outline: none;
      background: #fff;

      &::placeholder {
        color: #999;
      }

      &:focus {
        border-color: ${({ theme }) => theme.colors.secondary};
      }
    }
  }

  .exception-input-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 10px 12px;

    svg {
      color: #999;
      flex-shrink: 0;
    }

    input {
      border: none;
      outline: none;
      font-size: 1.2rem;
      color: #333;
      width: 100%;
      background: transparent;

      &::placeholder {
        color: #999;
      }

      &::-webkit-calendar-picker-indicator {
        display: none;
      }
    }
  }

  .remove-exception-button {
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    height: 42px;

    svg {
      color: #ff6b6b;
    }

    &:hover {
      background: #fff5f5;
      border-color: #ff6b6b;
    }
  }
`

export const PageFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding-top: 24px;
  border-top: 1px solid #e9ecef;
  margin-top: 24px;

  .cancel-button {
    padding: 12px 32px;
    border: 1px solid ${({ theme }) => theme.colors.secondary};
    background: #fff;
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.4rem;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #fff5f0;
    }
  }

  .submit-button {
    padding: 12px 32px;
    border: none;
    background: ${({ theme }) => theme.colors.secondary};
    color: #fff;
    font-size: 1.4rem;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      opacity: 0.9;
    }
  }
`

export const DeleteModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

export const DeleteModal = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  max-width: 420px;
  width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  h3 {
    font-size: 2rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    text-align: center;
  }

  p {
    font-size: 1.4rem;
    color: #666;
    line-height: 1.5;
    text-align: center;
    margin-bottom: 24px;
  }

  .modal-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
  }

  .cancel-button {
    flex: 1;
    padding: 12px 24px;
    border: 1px solid ${({ theme }) => theme.colors.secondary};
    border-radius: 8px;
    background: white;
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #f5f5f5;
    }
  }

  .delete-button {
    flex: 1;
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    background: #e74c3c;
    color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #c0392b;
    }
  }
`
